@if (readRole() || manageSelf()) {
    <app-container>
        <main class="max-w-[1520px] mx-auto w-full">
            <section
                class="flex flex-col gap-6 w-full pt-[5rem] overflow-hidden"
            >
                <section class="flex border divide-x">
                    <button
                        routerLink="/receipt/today"
                        class="segment"
                        [class.active]="segment() === 'today'"
                    >
                        금일 수납
                    </button>
                    <button
                        routerLink="/receipt/list"
                        class="segment"
                        [class.active]="segment() === 'list'"
                    >
                        회기 수납 내역
                    </button>
                    <button
                        routerLink="/receipt/other-list"
                        class="segment"
                        [class.active]="segment() === 'other-list'"
                    >
                        회기 외 수납 내역
                    </button>
                    @if (!isProduction) {
                        <button
                            routerLink="/receipt/abnormal-payment"
                            class="segment"
                            [class.active]="segment() === 'abnormal-payment'"
                        >
                            이상 결제 감지
                        </button>
                    }
                    <button
                        routerLink="/receipt/total"
                        class="segment"
                        [class.active]="segment() === 'total'"
                    >
                        총 수납내역
                    </button>
                </section>
                <router-outlet />
            </section>
        </main>
    </app-container>
} @else {
    <div class="p-4 pt-[10rem] flex flex-col gap-6">
        <div class="flex flex-col gap-3 items-center">
            <img src="no-permission.png" class="size-[5.375rem]" />
            <p class="text-center text-gray-800 text-xl font-semibold">
                권한이 없습니다.
            </p>
        </div>
        <p class="text-gray-500 text-center">
            해당 센터의 메뉴에 대한 권한이 없어 접근할 수 없습니다.
        </p>
    </div>
}
